import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
	DotsHorizontalOutline,
	IconButton,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	PencilAltOutline,
	rem,
	StyleProps,
	TrashOutline,
} from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { useEvaluationId } from '../../hooks/use-evaluation-id';
import { Feedback } from '../../lib';
import { useFeedbackContext } from '../context/feedback-context';
import { useEvaluation } from './context';

export const ActionMenu: FC<StyleProps> = (props: StyleProps) => {
	const { t } = useTranslation('feedback');
	const user = useCurrentUser();
	const evaluation = useEvaluation();
	const { confirmDelete, editEvaluation } = useFeedbackContext();
	const { evaluationId, clearId } = useEvaluationId();

	if (!evaluation.isPending() || !evaluation.receiverIs(user.id) || evaluation.isExpired()) {
		return null;
	}

	const handleEdit = (evaluation: Feedback) => {
		if (evaluationId === evaluation.id) {
			clearId();
		}

		editEvaluation(evaluation);
	};

	return (
		<Menu>
			<MenuButton
				aria-label={t('menu.label') as string}
				as={IconButton}
				bg="bg.softest"
				borderRadius="full"
				icon={<DotsHorizontalOutline size="sm" />}
				size="xs"
				_hover={{ bg: 'bg.soft' }}
				{...props}
			/>
			<MenuList bg="white" p={1} borderRadius="md" border="none">
				<MenuItem
					borderRadius="sm"
					h={rem(40)}
					p={2}
					icon={<PencilAltOutline />}
					onClick={() => handleEdit(evaluation)}
					_focus={{ bg: 'grayAlpha.150' }}
					_hover={{ bg: 'grayAlpha.100' }}
				>
					{t('edit.button')}
				</MenuItem>
				<MenuItem
					borderRadius="sm"
					h={rem(40)}
					p={2}
					icon={<TrashOutline />}
					onClick={() => confirmDelete(evaluation)}
					_focus={{ bg: 'grayAlpha.150' }}
					_hover={{ bg: 'grayAlpha.100' }}
				>
					{t('delete.button')}
				</MenuItem>
			</MenuList>
		</Menu>
	);
};
